import React from "react";
import { connect } from "react-redux";
import { formValueSelector, reduxForm, Field } from "redux-form";
import * as agent from "../agent";
import { Masks } from "../constants/enums";
import { required } from "../utility";
import { MaterialTextField, MaterialMaskedTextField } from "./MaterialInput";
import MaterialCombobox from "./MaterialCombobox";
import Button from '@material-ui/core/Button';
import SubmitButton from './SubmitButton';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const bodyTypes = [
    "Компактвэн",
    "Купе",
    "Купе легковой",
    "ЛА Джип",
    "ЛА Традиционный",
    "Легковой",
    "Легковой хэтчбек",
    "Легковой седан",
    "Легковой универсал",
    "Легковой/седан",
    "Легковые прочие",
    "Лимузин",
    "Минивэн",
    "Мотоцикл",
    "Пикап",
    "Полуприцеп",
    "Родстер",
    "Самосвал",
    "Седан",
    "Седан Легковой",
    "Тягач Седельный",
    "Универсал",
    "Хэтчбек - 3d",
    "Хэтчбек - 5d",
    "Хэтчбек (Комби) Легковой",
    "Эвакуатор",
    "Грузовой бортовой",
    "Бортовой",
    "Фургон",
    "Тягач"
];

const categories = ["A", "B", "B1", "B1/M", "BE", "C", "CE", "D", "DE", "M1", "Прицеп"];

class carDetailsForm extends React.Component {
    state = {
        suggestionsLoaded: false,
        brands: [],
        colors: [],
        pts: [],
        sts: []
    };
    componentWillMount() {
        agent.Cars.extra()
            .then(data => {
                const { brands, colors, pts, sts } = data;
                this.setState({ brands, colors, pts, sts, suggestionsLoaded: true });
            })
            .catch(e => alert(e));;
    }
    render() {
        const { contractId, pickedBrand, editMode, onCarDetailsSubmit, switchTab, handleSubmit } = this.props;
        const { brands, colors, pts, sts, suggestionsLoaded } = this.state;
        const models = (brands[pickedBrand] || []).reduce((a, c) => a.concat(c.model), []);
        return (
            <Paper className="common-paper m20">
                <form onSubmit={handleSubmit(data => onCarDetailsSubmit(contractId, data, () => switchTab(null, 2)))} >
                    <Grid container justify="center" spacing={16}>
                        <Grid item className="common-form common-column">
                            <Typography variant="h5" gutterBottom>Автомобиль:</Typography>
                            <Field component={MaterialMaskedTextField}
                                   mask={Masks.vin}
                                   name="vin"
                                   validate={required}
                                   label="VIN номер"/>
                            <Field name="brand"
                                   component={MaterialCombobox}
                                   suggestionsLoaded={suggestionsLoaded}
                                   validate={required}
                                   suggestions={Object.keys(brands)}
                                   label="Марка автомобиля" />
                            <Field name="model"
                                   component={MaterialCombobox}
                                   suggestionsLoaded={suggestionsLoaded}
                                   suggestions={models}
                                   validate={required}
                                   label="Модель автомобиля" />
                            <Field name="bodyColor"
                                   component={MaterialCombobox}
                                   suggestions={colors}
                                   suggestionsLoaded={suggestionsLoaded}
                                   validate={required}
                                   label="Цвет кузова" />
                            <Field name="bodyType"
                                   select
                                   component={MaterialTextField}
                                   label="Тип кузова" >
                               {bodyTypes.map((bt, i) => <MenuItem key={i} value={bt}>{bt}</MenuItem>)}
                            </Field>
                            <Field name="category"
                                   select
                                   component={MaterialTextField}
                                   label="Категория ТС" >
                               {categories.map((c, i) => <MenuItem key={i} value={c}>{c}</MenuItem>)}
                            </Field>
                            <Field component={MaterialMaskedTextField}
                                   mask={Masks.registrationNumber}
                                   validate={required}
                                   name="registryNumber"
                                   label="Регистрационный номер"/>
                            <Field component={MaterialMaskedTextField}
                                   mask={Masks.year}
                                   name="year"
                                   label="Год выпуска"/>
                            <Field name="engineNumber"
                                   component={MaterialTextField}
                                   label="Номер двигателя" />
                            <Field name="chassis"
                                   component={MaterialTextField}
                                   label="Шасси / рама" />
                            <Field name="bodyNumber"
                                   component={MaterialTextField}
                                   label="Кузов / коляска" />
                        </Grid>
                        <Grid item className="common-form common-column">
                            <Typography variant="h5" gutterBottom>Документы:</Typography>
                            <Field component={MaterialMaskedTextField}
                                   mask={Masks.ptsSerie}
                                   validate={required}
                                   name="ptsSerie"
                                   label="Серия ПТС"/>
                           <Field component={MaterialMaskedTextField}
                                  mask={Masks.ptsNumber}
                                  validate={required}
                                  name="ptsNumber"
                                  label="Номер ПТС"/>
                           <Field component={MaterialMaskedTextField}
                                  mask={Masks.date}
                                  validate={required}
                                  name="ptsDate"
                                  label="Дата выдачи ПТС"/>
                           <Field name="ptsIssued"
                                  component={MaterialCombobox}
                                  suggestions={pts}
                                  validate={required}
                                  suggestionsLoaded={suggestionsLoaded}
                                  isTextarea={true}
                                  label="Кем выдан ПТС" />
                           <Field component={MaterialMaskedTextField}
                                  mask={Masks.stsSerie}
                                  validate={required}
                                  name="stsSerie"
                                  label="Серия СТС"/>
                          <Field component={MaterialMaskedTextField}
                                 mask={Masks.stsNumber}
                                 validate={required}
                                 name="stsNumber"
                                 label="Номер СТС"/>
                          <Field component={MaterialMaskedTextField}
                                 mask={Masks.date}
                                 validate={required}
                                 name="stsDate"
                                 label="Дата выдачи СТС"/>
                          <Field name="stsIssued"
                                 component={MaterialCombobox}
                                 validate={required}
                                 suggestionsLoaded={suggestionsLoaded}
                                 suggestions={sts}
                                 isTextarea={true}
                                 label="Кем выдан СТС" />
                          <Field component={MaterialMaskedTextField}
                                 mask={Masks.keyNumber}
                                 name="keyNumber"
                                 label="Ключи в количестве"/>
                        </Grid>
                    </Grid>
                    <Grid container justify="center" spacing={16}>
                        <Grid item className="common-form common-column">
                            {!editMode &&
                                <Button fullWidth
                                        onClick={e => {
                                            e.preventDefault();
                                            switchTab(null, 0);
                                        }}
                                        size="large"
                                        variant="contained" >Назад</Button>
                            }
                        </Grid>
                        <Grid item className="common-form common-column">
                            <SubmitButton label={ editMode ? "Сохранить" : "Далее" } />
                        </Grid>
                    </Grid>
                </form>
            </Paper>
        );
    }
}

const mapStateToProps = (state, props) => {
    const { car: { brand, model, year, vin }, carDetails } = props;
    return {
        pickedBrand: formValueSelector("car-details-form")(state, "brand"),
        initialValues: Object.assign({
            brand,
            model,
            year,
            vin,
            chassis: "Отсутствует",
            bodyNumber: "Отсутствует"
        }, carDetails),
    };
};

const CarDetailsForm = reduxForm({ form: "car-details-form", enableReinitialize: true })(carDetailsForm);

export default connect(mapStateToProps, null)(CarDetailsForm);



// WEBPACK FOOTER //
// ./src/components/CarDetailsForm.js